import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "semantic-ui-react";
import MainMenu from "./../components/MainMenu";
import VodVideo from "../components/VodVideo";
import { fetchSessionById } from "./../reducers/learners";
import withRouter from "./../util/withRouter";

class Replay extends Component {
  componentDidMount() {
    this.props.fetchSessionById(this.props.params.session_id);
  }
  render() {
    return (
      <Container>
        <MainMenu />
        {this.props.learners.sessionToReplay.session_guid !== undefined ? (
          <VodVideo session={this.props.learners.sessionToReplay} />
        ) : null}
      </Container>
    );
  }
}

export default connect(
  (state) => ({
    learners: state.learners,
  }),
  { fetchSessionById }
)(withRouter(Replay));
